module.exports = __webpack_public_path__ + "static/media/never-busd.bad6e3e2.svg";